import React from "react";
import EventBanner from "../App/EventBanner";
import StreamTabs from "../../controllers/StreamTabs";
import PageBackgroundGlow from "../../controllers/PageBackgroundGlow";
import PageContainer from "../../components/PageContainer";
import Polls from "../../components/Polls";
import { ModalContextProvider } from "../../context/ModalContext";

export default ({children}) => {
    return (
        <>
            <EventBanner />
            <StreamTabs />
            <PageBackgroundGlow />
            <ModalContextProvider>
                <Polls isFixedDisplay={true} />
            </ModalContextProvider>

            <PageContainer>
                <section>
                    {children}
                </section>
            </PageContainer>
        </>
    );
}
